import React, { useState, useEffect } from 'react';
import { Table, Button, message } from 'antd';
import { EyeOutlined, CheckOutlined, CloseOutlined, EditOutlined, DeleteOutlined } from '@ant-design/icons';
import { loginRequest } from '../../authConfig';
import { useMsal } from '@azure/msal-react';
import axios from 'axios';
import ManageHelpCategory from './ManageHelpCategory';

interface HelpCategoryData{
    helpCategoryId:string;
    helpCategoryName:string;
    helpCategoryDescription: string;
    helpCategoryIcon: string;
    isActive:string;
    createdDate:boolean;
    createdBy:string;
    updatedDate:string;
    updatedBy:string;
}

const DisplayHelpCategory: React.FC = () => {
  const [helpCategoryData, setHelpCategoryData] = useState<HelpCategoryData[]>([]);
  const [isAddHelpCategoryVisible, setIsAddHelpCategoryVisible] = useState(false);
  const [isEditHelpCategoryVisible, setIsEditHelpCategoryVisible] = useState('');
  const { instance, accounts } = useMsal();
  const [selectedHelpCategoryId, setSelectedHelpCategoryId] = useState<string | null>(null); // Add this state

  const API_URL = process.env.REACT_APP_API_URL;

  const fetchToken = async () => {
        const res = await instance.acquireTokenSilent({
          ...loginRequest,
          account: accounts[0]
        });
        return res.idToken;
      };
    
      useEffect(() => {
        fetchToken();
      }, []);

      useEffect(() => {
        getHelpCategoryData();
      }, [isAddHelpCategoryVisible]);

      const userId = localStorage.getItem("UserId");

      const getHelpCategoryData = async () => {
        try {
          const token = await fetchToken();
          const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/HelpCategory/GetAllHelpCategoryData/`, {
            headers: {
              Authorization: `Bearer ${token}`,
              'Content-Type': 'application/json',
            }
          });
          setHelpCategoryData(response.data);
        } catch (error) {
          console.error("Error fetching help category details", error);
        }
      };

      const handleEditHelpCategoryData = async (helpCategoryId: string) => {
        setSelectedHelpCategoryId(helpCategoryId); // Set the selected faqId
        setIsAddHelpCategoryVisible(true);
      };

      const handleDeleteHelpCategoryData = async (helpCategoryId: string) => {
        const confirmed = window.confirm('Are you sure you want to delete this item?');
        if(confirmed){
          try {
            const token = await fetchToken();
            const response = await axios.post(`${process.env.REACT_APP_API_URL}/api/HelpCategory/DeleteHelpCategoryData`, 
              null,
            {
              params:{
                help_category_id: helpCategoryId,
                user_id: userId
              },
              headers: {
                Authorization: `Bearer ${token}`
              }
            });
            message.success('Help Category data deleted successfully.');
            getHelpCategoryData();
          } catch (error) {
            console.error("Error deleting details", error);
          }
        }
      };

      const columns = [
          {
            title: 'Category Name',
            dataIndex: 'helpCategoryName',
            key: 'helpCategoryName',
            // Custom render to allow wrapping
            render: (text: string) => (
            <div style={{ whiteSpace: 'normal', wordWrap: 'break-word' }}>{text}</div>
            ),
          },
          {
            title: 'Description',
            dataIndex: 'helpCategoryDescription',
            key: 'helpCategoryDescription',
            // Custom render to allow wrapping
            render: (text: string) => (
            <div style={{ whiteSpace: 'normal', wordWrap: 'break-word' }}>{text}</div>
            ),
          },
          {
            title: 'Icon',
            dataIndex: 'helpCategoryIcon',
            key: 'helpCategoryIcon',
          },
          {
            title: 'Actions', // This is the column header
            key: 'actions',
            render: (_: any, record: HelpCategoryData) => (
            <div style={{ display: 'flex', gap: '8px' }}>
            <Button
                icon={<EditOutlined />}
                style={{ color: 'white', backgroundColor: '#1890ff', borderColor: '#1890ff' }}
                onClick={() => handleEditHelpCategoryData(record.helpCategoryId)}
            >
                Edit
            </Button>

            <Button
                icon={<DeleteOutlined />}
                style={{ color: 'white', backgroundColor: '#ff4d4f', borderColor: '#ff4d4f' }}
                onClick={() => handleDeleteHelpCategoryData(record.helpCategoryId)}
            >
                Delete
            </Button>
            </div>
            ),
        }
        ];

  return (
    <div>
      <div style={{ marginBottom: 16 }}>
              <Button type="primary" onClick={() => setIsAddHelpCategoryVisible(false)} style={{ marginRight: 8 }}>
                View Help Category
              </Button>
              <Button type="primary" onClick={() => {
                setIsAddHelpCategoryVisible(true);
                setIsEditHelpCategoryVisible('');
                setSelectedHelpCategoryId(null);
              }} style={{ marginRight: 8 }}>
                Add Help Category
              </Button>
      </div>
              {isAddHelpCategoryVisible ? (<ManageHelpCategory helpCategoryId = {selectedHelpCategoryId} />) : (<Table dataSource={helpCategoryData} columns={columns} rowKey="helpCategoryId" />)}
    </div>
  );
};

export default DisplayHelpCategory;